<template>
	<div class="material-notification__item__info">
		<span v-html="data.content"></span>
		<div>
			<ui-button
				:text="data.closeButtonText || 'Close'"
				@click="onClose"
			/>
		</div>
	</div>
</template>

<script>
import UiButton from "lib/components/ui/Button";

export default {
	name: "NotificationInfo",
	components: {
		UiButton
	},
	props: {
		data: {
			type: [Object],
			required: true
		}
	},
	methods: {
		onClose() {
			this.data.onClose();
			this.$emit("notify-remove");
		}
	}
};
</script>

<style lang="scss" scoped>
.material-notification__item__info {
	display: flex;
	align-items: center;
	width: 100%;
	background-color: #4894ec;
	color: #fff;

	/deep/ span:first-child {
		flex-grow: 1;
		word-wrap: break-word;
		a {
			color: rgba(255,255,255,0.8);
			text-decoration: underline;
		}
		a:hover {
			color: #fff;
		}
	}
	button {
		color: #fff;
	}
}
</style>
